import { Decimal } from 'decimal.js';
// http://mikemcl.github.io/decimal.js/#
// https://github.com/MikeMcl/decimal.js
// npm install --save decimal.js
// ROUND_UP: 0;
// ROUND_DOWN: 1;
// ROUND_CEIL: 2;
// ROUND_FLOOR: 3;
// ROUND_HALF_UP: 4;
// ROUND_HALF_DOWN: 5;
// ROUND_HALF_EVEN: 6;
// ROUND_HALF_CEIL: 7;
// ROUND_HALF_FLOOR: 8;
// EUCLID: 9;

Decimal.set({
  toExpNeg: -9000000000000000,
  toExpPos: 9000000000000000,
  precision: 99,
  rounding: 4,
  modulo: 1,
  minE: -9e15,
  maxE: 9e15,
  crypto: false
})

let _seed = null;

/**
 * console.log("new Decimal(0.938044659618614761):" + new Decimal(0.938044659618614761))
 * console.log("new Decimal('0.938044659618614761'):" + new Decimal('0.938044659618614761'))
 * 
 * new Decimal(0.938044659618614761):0.9380446596186147
 * new Decimal('0.938044659618614761'):0.938044659618614761
 * 
 * console.log("new Decimal(0.938044659618614773):" + new Decimal(0.938044659618614773))
 * console.log("new Decimal(0.938044659618614774):" + new Decimal(0.938044659618614774))
 * 
 * new Decimal(0.938044659618614773):0.9380446596186147
 * new Decimal(0.938044659618614773):0.9380446596186148
 *
 */
class numberUtils {

  /** 
  * Id
  */
  static uid() {
    _seed = _seed || (new Date()).valueOf();
    _seed++;
    return _seed;
  }


  /**
   *
   */
  static toNumber(a, n, rounding) {
    if (!a) return 0;
    return new Decimal(new Decimal(a).toFixed(n, rounding)).toNumber();
  }

  /**
   *
   */
  static format(a, n, rounding) {
    if (!a) return "0";
    return new Decimal(new Decimal(a).toFixed(n, rounding)).toString();
  }

  /**
   *
   */
  static decimalPlaces(a, n, rounding) {
    if (!a) return 0;
    return new Decimal(this.format(a, n, rounding)).decimalPlaces();
  }
  static dp(a, n, rounding) {
    if (!a) return 0;
    return new Decimal(this.format(a, n, rounding)).dp();
  }

  /**
   *
   */
  static add(a, b, n, rounding) {
    if (!a && !b) return "0";
    let addAmount = new Decimal(a || 0).add(b || 0);
    return this.format(addAmount, n, rounding);
  }

  /**
   *
   */
  static addAll([...values], n, rounding) {
    let addAmount = new Decimal(0);
    values.forEach(v => {
      if (!!v) {
        try {
          addAmount = addAmount.add(new Decimal(v));
        } catch (error) {
          console.log('add error >> ', v, error);
        }
      }
    })
    return this.format(addAmount, n, rounding);
  }

  /**
   *
   */
  static sub(a, b, n, rounding) {
    if (!a && !b) return "0";
    let subAmount = new Decimal(a || 0).sub(b || 0);
    return this.format(subAmount, n, rounding);
  }

  /**
  *
  */
  static subAll([...addValues], [...subValues], n, rounding) {
    let addAmount = new Decimal(0);
    addValues.forEach(v => {
      if (!!v) {
        try {
          addAmount = addAmount.add(new Decimal(v));
        } catch (error) {
          console.log('sub add add error >> ', v, error);
        }
      }
    })

    let subAmount = new Decimal(0);
    subValues.forEach(v => {
      if (!!v) {
        try {
          subAmount = subAmount.add(new Decimal(v));
        } catch (error) {
          console.log('sub add sub error >> ', v, error);
        }
      }
    })

    return this.format(addAmount.sub(subAmount), n, rounding);
  }

  /**
   *
   */
  static mul(a, factor, n, rounding) {
    if (!a || (!factor && typeof factor !== 'number')) {
      return "0";
    }
    let mulAmount = new Decimal(a || 0).mul(factor || 0);
    return this.format(mulAmount, n, rounding);
  }

  /**
   *
   */
  static mulAll([...values], n, rounding) {
    let mulAmount = undefined;
    values.forEach(v => {
      if (v !== null && v !== undefined && v !== "") {
        try {
          if (mulAmount == undefined) {
            mulAmount = new Decimal(v);
          } else {
            mulAmount = mulAmount.mul(new Decimal(v || 0));
          }
        } catch (error) {
          console.log('mul error >> ', v, error);
        }
      }
    })

    return this.format(mulAmount, n, rounding);
  }

  /**
   *
   */
  static div(a, b, n, rounding) {
    if (!b || b == "0") return null;
    let divAmount = new Decimal(a || 0).div(b);
    return this.format(divAmount, n, rounding);
  }

  /**
  *
  */
  static divAll([...mulValues], [...divValues], n, rounding) {
    let mulAmount = undefined;
    mulValues.forEach(v => {
      if (v !== null && v !== undefined && v !== "") {
        try {
          if (mulAmount == undefined) {
            mulAmount = new Decimal(v);
          } else {
            mulAmount = mulAmount.mul(new Decimal(v || 0));
          }
        } catch (error) {
          console.log('div mul mul error >> ', v, error);
        }
      }
    })

    let divAmount = undefined;
    divValues.forEach(v => {
      if (v !== null && v !== undefined && v !== "") {
        try {
          if (divAmount == undefined) {
            divAmount = new Decimal(v);
          } else {
            divAmount = divAmount.mul(new Decimal(v || 0));
          }
        } catch (error) {
          console.log('div mul div error >> ', v, error);
        }
      }
    })

    if (mulAmount === undefined || divAmount === undefined || this.comparedTo(divAmount, '0') == 0) {
      return null;
    }

    return this.format(mulAmount.div(divAmount), n, rounding);
  }

  /**
   *
   */
  static movePointLeft(a, n) {
    if (!a || a == "0") return 0;
    return this.div(a, new Decimal("10").toPower(n));
  }

  /**
   *
   */
  static movePointRight(a, n) {
    if (!a || a == "0") return 0;
    return this.mul(a, new Decimal("10").toPower(n));
  }

  /**
  *
  */
  static comparedTo(a, b) {
    try {
      return new Decimal(a).comparedTo(new Decimal(b));
    } catch (error) {
      return null;
    }
  }

  static min(...values) {
    try {
      return Decimal.min(...values);
    } catch (error) {
      return null;
    }
  }

  static max(...values) {
    try {
      return Decimal.max(...values);
    } catch (error) {
      return null;
    }
  }

  static isPositiveInteger(number) {
    let numReg = /^[0-9]*$/
    let numRe = new RegExp(numReg)
    if (!numRe.test(number)) {
      return false
    }
    return true;
  }
}
export default numberUtils;



// WEBPACK FOOTER //
// ./src/models/numberUtils.js